// extracted by mini-css-extract-plugin
export var callCard = "_rv-0";
export var callMessageButton = "_rv-1";
export var helpIcon = "_rv-3";
export var helpIconContainer = "_rv-4";
export var verticalDivider = "_rv-2";